(() => {
  const panel = document.getElementById('VoviHeaderSearch');
  const toggle = document.querySelector('[data-search-toggle]');
  if (!panel || !toggle) return;
  const input = panel.querySelector('input');
  const list = panel.querySelector('ul');
  const status = panel.querySelector('[role="status"]');
  const form = panel.querySelector('form');
  let timer, request, version = 0;
  const cache = new Map();
  toggle.setAttribute('role', 'button');
  const close = (restore = true) => {
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    clearTimeout(timer);
    request?.abort();
    version++;
    list.removeAttribute('aria-busy');
    if (restore) toggle.focus({ preventScroll: true });
  };
  const render = items => {
    list.replaceChildren();
    status.textContent = items.length ? `${items.length} passende Motive` : 'Keine passenden Motive gefunden. Versuche einen anderen Suchbegriff.';
    items.forEach(item => {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = item.href;
      const img = document.createElement('img');
      img.src = item.src;
      img.alt = '';
      img.width = 64; img.height = 80; img.loading = 'lazy';
      const text = document.createElement('span');
      const title = document.createElement('strong');
      title.textContent = item.title;
      const price = document.createElement('span');
      price.textContent = item.price;
      text.append(title, price);
      a.append(img, text); li.append(a); list.append(li);
    });
  };
  const search = async () => {
    clearTimeout(timer);
    request?.abort();
    const ownVersion = ++version;
    const query = input.value.trim();
    list.replaceChildren();
    list.removeAttribute('aria-busy');
    if (!query) { status.textContent = 'Suche nach einem Motiv, Thema oder Anlass.'; return; }
    if (cache.has(query)) { render(cache.get(query)); return; }
    status.textContent = 'Motive werden gesucht …';
    list.setAttribute('aria-busy', 'true');
    request = new AbortController();
    const url = new URL(panel.dataset.searchUrl, location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('section_id', 'vovi-live-results');
    try {
      const response = await fetch(url, { signal: request.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('Search unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (!html.querySelector('[data-search-section]')) throw new Error('Missing search section');
      const items = [...html.querySelectorAll('.vovi-product-card')].map(card => ({
        href: card.querySelector('a').getAttribute('href'),
        src: card.querySelector('img').getAttribute('src'),
        title: card.querySelector('h2').textContent,
        price: card.querySelector('.vovi-listing-price').textContent
      }));
      if (ownVersion !== version || panel.hidden) return;
      if (cache.size >= 20) cache.delete(cache.keys().next().value);
      cache.set(query, items);
      render(items);
    } catch (error) {
      if (error.name !== 'AbortError' && ownVersion === version) status.textContent = 'Die Suche ist gerade nicht verfügbar. Bitte versuche es erneut.';
    } finally { if (ownVersion === version) list.removeAttribute('aria-busy'); }
  };
  toggle.addEventListener('click', event => {
    event.preventDefault();
    if (!panel.hidden) { close(); return; }
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    input.focus({ preventScroll: true });
    if (input.value.trim()) search();
  });
  toggle.addEventListener('keydown', event => { if (event.key === ' ') { event.preventDefault(); toggle.click(); } });
  panel.querySelector('[data-search-close]').addEventListener('click', () => close());
  input.addEventListener('input', () => {
    clearTimeout(timer);
    request?.abort();
    version++;
    list.replaceChildren();
    list.removeAttribute('aria-busy');
    status.textContent = input.value.trim() ? 'Motive werden gesucht …' : 'Suche nach einem Motiv, Thema oder Anlass.';
    timer = setTimeout(search, 200);
  });
  form.addEventListener('submit', event => { event.preventDefault(); search(); });
  panel.addEventListener('keydown', event => {
    if (event.key === 'Escape') { event.preventDefault(); close(); }
    const links = [...list.querySelectorAll('a')];
    const index = links.indexOf(document.activeElement);
    if (event.key === 'ArrowDown') { event.preventDefault(); (links[index + 1] || links[0])?.focus(); }
    if (event.key === 'ArrowUp') { event.preventDefault(); if (index <= 0) input.focus(); else links[index - 1].focus(); }
  });
  document.addEventListener('click', event => {
    if (!panel.hidden && !panel.contains(event.target) && !toggle.contains(event.target)) close(false);
  });
})();
